<template>
  <el-dialog
    custom-class="real-dialog"
    title="修改密码"
    :visible="dialogVisible"
    width="800px"
    @close="handleClose"
    append-to-body
    center
  >
    <el-row type="flex" justify="center" class="dialog-change-account-form">
      <el-col :span="12">
        <el-form ref="pwdForm" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="原密码" prop="oldPwd">
            <el-input
              placeholder="请输入原密码"
              v-model="form.oldPwd"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPwd">
            <el-input
              placeholder="请输入新密码"
              v-model="form.newPwd"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPwd">
            <el-input
              placeholder="请再次输入新密码"
              v-model="form.checkPwd"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleClick">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import showdialog from '../../../minxs/showdialog'

export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        oldPwd: "",
        newPwd: "",
        checkPwd: "",
      },
      rules: {
        oldPwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        checkPwd: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  mixins:[showdialog],
  watch: {
    showDialog(v) {
      this.dialogVisible = v;
      this.input = "";
    },
    dialogVisible(v) {
      if(v){
           this.$refs.pwdForm.resetFields();
      }
      this.$emit("update:showDialog", v);
    },
  },
  methods: {
    handleClick() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // console.log(this.input);
    },
  },
};
</script>

